import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitDeductionsSaga } from '../sagas/submitDeductionsSaga';

export function* NDFL3LightIISDeductionsSaga() {
  yield takeEvery(actionTypes.SUBMIT, submitDeductionsSaga);
}
